module.exports = __webpack_public_path__ + "media/images/certificate/ncce-logo-certificate-b9fe4f9f0ac159fd433ec73486c1c1c8.svg";